import { SxProps, ThemeOptions } from '@mui/material'

import { ThemeConfig } from '../config'
import { PageSize } from '../enums'
import { LocationType } from '../types'

export const MAX_NUMBER_COLS_SORTED = 5 as const
export const DEFAULT_PAGE_SIZE = 10 as const
export const NO_DATA_ROWS = 1 as const
export const DEFAULT_TAKE = 100 as const
export const ADD_PATH = 'add' as const
export const BUTTONS_GAP = 0.75 as const
export const ELEMENT_HEIGHT = ThemeConfig.spacing.xl * 4.8
export const GRID_MARGIN_TOP = ThemeConfig.spacing.xs * 4
export const MAX_DATE = new Date('2099-12-31')
export const MR = '2.3rem'
export const CELL_PADDING = '0.15rem' as const
export const TABLE_CELL_STYLE: SxProps = {
  fontWeight: '700 !important',
  py: CELL_PADDING,
  textAlign: 'left',
  verticalAlign: 'top',
} as const

export const rowsPerPageOptions = [
  PageSize.sm,
  PageSize.md,
  PageSize.lg,
  PageSize.xl,
]
export const MONDAY = 1
export const FRIDAY = 5
export const HttpCode = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
}
export const MAX_VALID_VALUE = 99999990 as const

export const allLocations: LocationType[] = [
  { code: 1, name: 'Aalsmeer' },
  { code: 2, name: 'Naaldwijk' },
  { code: 3, name: 'Rijnsburg' },
  { code: 25, name: 'RFH Concern' },
]

export const concernLocations: LocationType[] = [
  { code: 1, name: 'Aalsmeer' },
  { code: 2, name: 'Naaldwijk' },
  { code: 3, name: 'Rijnsburg' },
]

export const gridHeaderStyles = {
  '& .MuiDataGrid-columnHeaders': {
    maxHeight: '6rem !important',
  },
  '& .MuiDataGrid-columnHeadersInner': {
    paddingBottom: '0.5rem',
    paddingTop: '0.25rem',
  },
  '& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    flexDirection: 'row',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    // marginBottom: '0.25rem',
    paddingBottom: '0.25rem',
    lineHeight: 1.2,
    textAlign: 'center',
    textOverflow: 'clip',
    whiteSpace: 'break-spaces',
  },
  '& .MuiDataGrid-toolbarContainer': {
    gap: 0,
  },
}

export const typographyStyles = {
  display: 'flex',
  padding: 0,
  justifyContent: 'space-between',
  my: ThemeConfig.spacing.xs,
  overflowWrap: 'anywhere',
}

export const gridSx = {
  display: 'flex',
  padding: 0,
  justifyContent: 'space-between',
  my: ThemeConfig.spacing.xs,
}

export const gridSmallStyles = (theme: ThemeOptions): SxProps => ({
  [theme.breakpoints.only('xs')]: {
    display: 'block',
  },
})

export const boxLoaderStyles = (isCard: boolean): SxProps => ({
  backgroundColor: 'white',
  padding: ThemeConfig.spacing.sm,
  minHeight: '125px',
  display: !isCard ? 'flex' : '',
  justifyContent: !isCard ? 'center' : '',
  alignItems: !isCard ? 'center' : '',
})
